/**
 * Construct currency format, currently support rupiah only
 *
 * @param {string | number} number
 * @param {boolean} currency
 * @returns string
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: ()=>_default
});
const formatMoney = (number, currency)=>{
    if (currency === void 0) currency = true;
    return `${currency ? "Rp " : ""}${parseInt(String(number || 0), 10).toFixed(0) // always two decimal digits
    .replace(".", ",") // replace decimal point character with ,
    .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.")} `;
};
const _default = formatMoney;
